// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"309391c7","239":"422607f5","395":"9fd157fd","488":"04f6ff8e","602":"3bcf8708","732":"d14f9c50","977":"ce6947d3"}[chunkId] + ".chunk.js";
};